export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=709ec848a6d94fc5182d9bcb08a10086ef42705303&name=pushAdClickData!'